<dialog #rfqDialog class="rfq-dialog">
  <h4>{{ header }}</h4>
  <div class="rfq-dialog__text-container scrollable-content">
    <p *ngFor="let msg of messages">
      @switch (msg.messageType) {
        @case ('warning') {
          <cds-icon
            shape="warning-standard"
            solid="true"
            class="warning"
          ></cds-icon>
        }
        @case ('error') {
          <cds-icon
            shape="error-standard"
            solid="true"
            class="error"
          ></cds-icon>
        }
      }
      {{ msg.message }}
    </p>
  </div>
  <div class="rfq-dialog__footer">
    <button
      class="rfq-dialog__footer__cancel ui-button primary ui-button__footer"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      *ngIf="onConfirm"
      class="rfq-dialog__footer__confirm ui-button primary ui-button__footer"
      (click)="confirm()"
    >
      Confirm
    </button>
  </div>
</dialog>
